import { useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import styles from "./index.module.scss";
import Button from "../../common/button";

export default function VideoFull() {
  const { contacts } = useSelector((state) => state.contacts);

  const phone = useMemo(() => {
    return contacts?.phone;
  }, [contacts]);
  const [phoneValue, setPhoneValue] = useState(phone);

  useEffect(() => {
    setPhoneValue(phone);
  }, [phone]);

  useEffect(() => {
    const phoneLink = document.getElementById("phoneLink");
    if (!phoneLink) return;
    const textPhone = phoneLink.textContent?.trim();
    if (textPhone) {
      setPhoneValue(textPhone);
      return;
    }
    const href = phoneLink.getAttribute("href");
    if (href?.startsWith("tel:")) {
      setPhoneValue(href.replace("tel:", "").trim());
    }
  }, []);
  return (
    <div className={styles.Content}>
      <iframe
        width="800"
        height="450"
        src="https://kinescope.io/embed/5AfSWUCv2PRrhPpm8sqHp8"
        allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write; screen-wake-lock;"
        frameBorder="0"
        allowFullScreen
      ></iframe>
      <div className={styles.Buttons}>
        <div>
          <a href={`tel:${phoneValue}`} className={contacts?.calltouchCode}>
            {phoneValue}
          </a>
          <a href={`https://wa.me/+79811779326`}>
            <img src="/videoBanner/wp.svg" />
            Написать в Whatsapp
          </a>
          <a href={`https://t.me/farkop_rubot`}>
            <img src="/videoBanner/tg.svg" />
            Написать в Телеграм
          </a>
        </div>

        <Button
          styles={{ width: "200px" }}
          label={"Подобрать фаркоп"}
          onClick={() => {
            window.location.href = "/catalog/farkopy/";
          }}
        ></Button>
      </div>
      <div className={styles.Social}>
        <span>Следите за новостями:</span>
        <div>
          <a href="https://vk.com/farkopru" target="_blank" rel="noreferrer">
            <img src="/videoBanner/vk.svg" />
          </a>
          <a
            href="https://www.drive2.ru/users/farkopru"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/videoBanner/drive2.svg" />
          </a>
          <a href="https://dzen.ru/farkop.ru" target="_blank" rel="noreferrer">
            <img src="/videoBanner/dzen.svg" />
          </a>
          <a href="https://t.me/farkop_rubot" target="_blank" rel="noreferrer">
            <img src="/videoBanner/telegram.svg" />
          </a>
          <a
            href="https://rutube.ru/channel/33712357/"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/videoBanner/rutube.svg" />
          </a>
        </div>
      </div>
    </div>
  );
}
